<template>
  <div class="ELYXModalBase" :style="getCustomBaseStyles">
    <div class="ELYXModalBase--container" :style="getCustomContainerStyles">
      <component :is="activeModal.name" @closeModal="closeModal"></component>
    </div>
    <div class="ELYXModal--blur" v-if="modalStyles.blur.blurIsActive" :style="getCustomBlurStyles" @click="handleModalBackgroundClick"></div>
  </div>
</template>

<script>
import { ELYXCentralStore } from "../ELYX/ELYXStore";
import isMobile from "ismobilejs";

export default {
  components: {
    CalendarBookingRestrictionModal: () => import(`../ELYX/Calendar/CalendarBookingRestrictionModal.vue`),
    CalendarBookingFrozenModal: () => import(`../ELYX/Calendar/CalendarBookingFrozenModal.vue`),
    CalendarRequestFailedModal: () => import(`../ELYX/Calendar/CalendarRequestFailedModal.vue`),
    SubscriptionModal: () => import(`../ELYX/Subscriptions/SubscriptionModal.vue`),
    SubscriptionModalSuccess: () => import(`../ELYX/Subscriptions/SubscriptionModalSuccess.vue`),
    SubscriptionModalFail: () => import(`../ELYX/Subscriptions/SubscriptionModalFail.vue`),
    Settings: () => import(`../ELYX/Settings/Settings.vue`),
    CalendarBookingLimitInfoModal: () => import(`../ELYX/Calendar/CalendarBookingLimitInfoModal.vue`),

    /** Spaces route ONLY modals */
    SubspaceModalDeletion: () => import(`../ELYX/Subspaces/SubspaceModalDeletion.vue`),

    /** OLD CODE SETUP MODALS */
    Tasks: () => import(`../components/Nav/Dropdowns/Tasks.vue`),
  },
  computed: {
    activeModal: () => ELYXCentralStore.state.activeModal,
    modalStyles() {
      return this.activeModal.styles;
    },

    getCustomBaseStyles() {
      let styles = ``;
      const baseStyles = this.modalStyles.base;
      if (baseStyles.background) {
        styles += `background: ${baseStyles.background};`;
      }
      if (isMobile().phone) {
        styles += `align-items: flex-start !important;`;
      }
      return styles;
    },

    getCustomContainerStyles() {
      let styles = ``;
      const containerStyles = this.modalStyles.container;
      if (containerStyles.minWidth) {
        styles += `min-width: ${containerStyles.minWidth}px;`;
      }
      if (containerStyles.blurStrength) {
        styles += `
          -webkit-backdrop-filter: blur(${containerStyles.blurStrength}px);
          backdrop-filter: blur(${containerStyles.blurStrength}px);
        `;
      }
      if (containerStyles.backdropFilter) {
        styles += `
            -webkit-backdrop-filter: ${containerStyles.backdropFilter};
            backdrop-filter: ${containerStyles.backdropFilter};
          `;
      }

      if (this.activeModal.widthBreakOff && this.$windowWidth <= this.activeModal.widthBreakOff) {
        if (containerStyles.customBreakOffContainer) {
          styles += containerStyles.customBreakOffContainer;
        } else {
          /* When small view, then box starts from left corner and is scrollable */
          styles += `
            justify-content: flex-start;
            overflow-x: scroll;
            border-radius: 0px;
          `;
        }
      }
      if (this.activeModal.heightBreakOff && this.$windowHeight <= this.activeModal.heightBreakOff) {
        styles += `
          border-radius: 0px;
        `;
      }
      if (this.activeModal.isInfoModal) {
        styles += `
          border-radius: 16px !important;
        `;
      }
      return styles;
    },

    getCustomBlurStyles() {
      let styles = ``;
      const blurStyles = this.modalStyles.blur;
      if (blurStyles.blurIsActive && blurStyles.blurBackground) {
        styles += `background-color: ${blurStyles.blurBackground};`;
      }
      return styles;
    },
  },
  methods: {
    closeModal() {
      ELYXCentralStore.methods.closeModal();
    },
    handleModalBackgroundClick() {
      /** If modal is meant to be closed via background click, close it. */
      if (this.activeModal.canCloseFromBackground) {
        this.closeModal();
      }
    },
  },
};
</script>

<style scoped>
.ELYXModalBase {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  background: #ffffff80;
}
.ELYXModalBase--container {
  border-radius: 16px;
  background-color: rgba(255, 255, 255, 0.5);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ELYXModal--blur {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: 0;
  backdrop-filter: blur(10px);
}
</style>
